<template>
	<div v-if="playlist_url">
		<k-panel class="elevation-1">
			<template #title>Vod</template>

			<template #buttons>
				<k-menu offset-y right :close-on-content-click="false">
					<template slot="activator" slot-scope="{ on }">
						<k-btn icon v-on="on"><k-icon size="s">help_outline</k-icon></k-btn>
					</template>
					<template #default>
						<div class="vod-help">
							<div class="vod-help-title">Keyboard shortcuts</div>
							<table>
								<tr><td><kbd>&larr;</kbd> / <kbd>&rarr;</kbd></td><td>Seek 1 second backward / forward</td></tr>
								<tr><td><kbd>Alt</kbd> + <kbd>&larr;</kbd> / <kbd>&rarr;</kbd></td><td>Seek 5 seconds backward / forward</td></tr>
								<tr><td><kbd>Shift</kbd> + <kbd>&larr;</kbd> / <kbd>&rarr;</kbd></td><td>Seek 10 seconds backward / forward</td></tr>
								<!--<tr><td><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>&larr;</kbd> / <kbd>&rarr;</kbd></td><td>Step one frame backward / forward</td></tr>-->
								<tr><td><kbd>Space</kbd></td><td>Play / pause</td></tr>
								<tr><td><kbd>&darr;</kbd></td><td>Set In point to the current position</td></tr>
								<tr><td><kbd>&uarr;</kbd></td><td>Set Out point to the current position</td></tr>
								<tr><td><kbd>Alt</kbd> + <kbd>Q</kbd></td><td>Set In point to the current position</td></tr>
								<tr><td><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>Q</kbd></td><td>Seek to the In point</td></tr>
								<tr><td><kbd>Alt</kbd> + <kbd>W</kbd></td><td>Set Out point to the current position</td></tr>
								<tr><td><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>W</kbd></td><td>Seek to the Out point</td></tr>
								<tr><td><kbd>Alt</kbd> + <kbd>R</kbd></td><td>Refresh the player (keeps the current position)</td></tr>
								<tr><td><kbd>Alt</kbd> + <kbd>S</kbd></td><td>Open the save dialog</td></tr>
							</table>
							<div class="vod-help-note">Shortcuts are disabled while typing in a text field or while the tag dialog is open.</div>
						</div>
					</template>
				</k-menu>
			</template>

			<template #default>
					<k-video-player
						autoplay
						:hide-bar="false"
						:volume="1.0"
						v-if="playlist_url"
						:url="playlist_url"
						ref="player"
						:position="player_position"
						v-on:position-duration="position_duration"
						v-on:loaded="player_loaded"
						:pause-on-refresh="true"
					></k-video-player>
					<div v-if="!playlist_url">Cannot load video</div>
			</template>

			<template #footer>
				<k-btn size="m" icon icon-name="refresh" v-on:click="refresh_player"></k-btn>
				<k-btn size="m" color="primary" style="width: 120px;" :disabled="is_slider" v-on:click="set_in_position">In ({{format_time(in_position)}})</k-btn>
				<k-btn size="m" color="primary" style="width: 120px;" :disabled="is_slider" v-on:click="set_out_position">Out ({{format_time(out_position)}})</k-btn>
<!--
				<k-menu offset-y :close-on-content-click="false"  :close-on-click="false" :nudge-width="150" v-model="save_dialog" v-if="!use_save_dialog" :transition="false">
					<k-btn size="m" color="success" slot="activator">Save</k-btn>
        			<div v-if="save_dialog">
	    	    		<clip-editor ref="clip_editor" :event-uuid="uuid" :in-position="in_position" :out-position="out_position" v-on:save="create_clip"></clip-editor>
	    	    	</div>
      			</k-menu>-->

	      		<k-dialog width="400" v-model="save_dialog" :transition="false">
	      			<template #activator>
			      		<k-btn size="m" style="padding-right: var(--ks-padding-4); padding-left: var(--ks-padding-4);" color="success" @click="save_dialog = !save_dialog">Save</k-btn>
			      	</template>
	    	  		<div v-if="save_dialog" class="ks-floating-menu">
        				<clip-editor ref="clip_editor" :event-uuid="uuid" :in-position="in_position" :out-position="out_position" @close="save_dialog=false" v-on:save="create_clip"></clip-editor>
        			</div>
	      		</k-dialog>

				<k-btn size="m" color="primary" :disabled="is_slider && isNaN(in_position)" v-on:click="seek_to_in_position"><k-icon>first_page</k-icon></k-btn>
				<k-btn size="m" color="primary" :disabled="is_slider && isNaN(out_position)" v-on:click="seek_to_out_position"><k-icon>last_page</k-icon></k-btn>
				<k-btn size="m" color="primary" :disabled="is_slider" v-on:click="play_clip"><k-icon>play_arrow</k-icon></k-btn>


				<k-dialog offset-y :close-on-content-click="false" :close-on-click="false" :nudge-width="150" v-model="tag_dialog" v-if="!use_save_dialog" :transition="false">
					<template #activator>
						<k-btn size="m" color="primary" slot="activator" @click="tag_dialog = !tag_dialog">Add Tag</k-btn>
					</template>

					<div v-if="tag_dialog" class="ks-floating-menu">
						<tag-editor :event_uuid="uuid" :position="position" v-on:save="tag_dialog=false" @close="tag_dialog=false"></tag-editor>
        			</div>
				</k-dialog>

				<k-dialog width="800" v-model="export_dialog" v-if="mtv_special_visible">
					<k-btn size="m" color="primary" slot="activator" @click="export_dialog = !export_dialog" >MTV compilation export</k-btn>

          <div v-if="export_dialog" class="ks-floating-menu">
						<export-mtv-special-editor
              v-model="export_dialog"
              :event_uuid="uuid"
              v-if="export_dialog"
              v-on:exported="export_dialog=false"
              @close="export_dialog=false"
            ></export-mtv-special-editor>
					</div>
				</k-dialog>
			</template>
		</k-panel>

<!--		<k-layout>
			<k-flex c12>
				<vue-slider
					class="ml-4 mr-4"
					v-if="!is_slider"
					:min="0" :max="duration" :speed="0" :value="slider_value" tooltip-dir="bottom" v-on:callback="change_slider_position" :process-dragable="false"
					:slider-style="{'border-radius': '0px'}"
					:dot-width="5" :dot-height="20" :formatter="tooltip_formatter">
				</vue-slider>
			</k-flex>
		</k-layout>-->
		</k-panel>
	</div>
</template>

<script>
import vueSlider from 'vue-slider-component';
import ClipEditor from './Clip.vue';
import ExportMtvSpecialEditor from './ExportMtvSpecial.vue';
import TagEditor from '../events/tags/Editor.vue';

export default {
	props: ["uuid", "new-in-position", "new-out-position", "new-positions", "use-save-dialog", "disable-key-events"],
	components: {
		vueSlider,
		ClipEditor,
		TagEditor,
		ExportMtvSpecialEditor
	},
	data () {
		var config_ch = this.$cloudserver.channel("events:clip_settings:"+this.uuid);
		return {
			ws_channel: config_ch,
			playlist_url: undefined,
			position: undefined,
			duration: undefined,
			in_position: undefined,
			out_position: undefined,
			player_position: undefined,
			slider_value: [0,0],
			playlist_url_tmp: undefined,
			save_dialog: false,
			tag_dialog: false,
			export_dialog: false,
			info: {
				title: "",
				description: "",
				tags: ""
			}
		}
	},
	watch: {
		"newInPosition": function(newVal) {
			if (newVal < 0) newVal = 0;
			this.change_in_position(newVal);
			this.seek_to_in_position();
		},
		"newOutPosition": function(newVal) {
			if (newVal < 0) newVal = 0;
			this.change_out_position(newVal);
		},
		"newPositions": function(newVal) {
			var in_pos = newVal[0];
			var out_pos = newVal[1];
			if (in_pos < 0) in_pos = 0;
			if (out_pos < 0) out_pos = 0;
			if (in_pos > this.duration || out_pos > this.duration) {
				this.$nextTick(function() {
					this.refresh_video();
					this.change_in_position(in_pos);
					this.seek_to_in_position();
					this.change_out_position(out_pos);
				});
			} else {
				this.change_in_position(in_pos);
				this.seek_to_in_position();
				this.change_out_position(out_pos);
			}
		},
		"ws_channel.data": {
			handler(newVal, oldVal) {
				this.playlist_url = newVal.preview_playlist_url;
				this.playlist_url_tmp = newVal.preview_playlist_url;
			},
			deep: true
		},
		"save_dialog": function(newVal) {
			if (newVal == true) {

			}
		}

	},
	mounted () {
		var in_pos = undefined;
		var out_pos = undefined;
		if (typeof(this.newPositions) != "undefined") {
			in_pos = this.newPositions[0];
			out_pos = this.newPositions[1];
		}
		if (typeof(in_pos) != "undefined" && typeof(out_pos) != "undefined") {
			this.change_in_position(in_pos);
			this.seek_to_in_position();
			this.change_out_position(out_pos);
		}
	},
	created () {
		var self = this;
		this.ws_channel.join();

		window.addEventListener('keydown', this.keyDown);
		window.addEventListener('keyup', this.keyUp);
		window.addEventListener('blur', this.stop_arrow_repeat);

	},
	methods: {
		format_time (time, paddedHours) {
			if (isNaN(time) || typeof(time) == "undefined") {
				return "--:--";
			}
		  time = time * 1000
  		time = parseInt(time/1000)
  		const seconds = time % 60
  		time = parseInt(time/60)
  		const minutes = time % 60
  		time = parseInt(time/60)
  		const hours = time % 24
  		const days = parseInt(time/24)
  		let out = ''
  		if (days && days > 0) {
    		out += days + ':'
    		if (hours < 1) out += '00:'
  		}
  		if (hours && hours > 0 || paddedHours) out += ('0' + hours).slice(-2) + ':'
  		out += ('0' + minutes).slice(-2) + ':'
  		out += ('0' + seconds).slice(-2)
  		return out.trim()
		},
		tooltip_formatter(v, a) {
			return this.format_time(v);
		},
		play_clip () {
			this.$refs.player.play_clip(this.in_position, this.out_position);
		},

		position_duration(value) {
			this.position = value.position;
			this.duration = value.duration;
		},


		create_clip() {
			var data = {duration: this.duration, position: this.position, in_position: this.in_position, out_position: this.out_position, info: this.info};
			this.$emit("clip", data);
			this.save_dialog = false;
		},
		refresh_player () {
			if (this.$refs.player) this.$refs.player.refresh();
		},
		refresh_video (cb) {
			this.playlist_url = "";
			this.position = undefined;
			this.duration = undefined;
			this.$nextTick(function () {
				this.playlist_url = this.playlist_url_tmp;
				if (typeof(cb) == "function") {
					cb();
				}
			});
		},
		change_slider_position (new_value) {
			var seek_marker = 0;
			if (this.out_position != new_value[1]) seek_marker = 1;
			if (this.in_position != new_value[0]) seek_marker = 0;

			this.in_position = new_value[0];
			this.out_position = new_value[1];

			this.seek(new_value[seek_marker]);
		},


		update_slider () {
			this.slider_value = [this.in_position, this.out_position];
		},
		set_in_position () {
			this.in_position = this.position;
			this.update_slider();
		},
		set_out_position () {
			this.out_position = this.position;
			this.update_slider();
		},
		change_out_position(value) {
			this.out_position = value;
			this.update_slider();
		},
		change_in_position(value) {
			this.in_position = value;
			this.update_slider();
		},
		seek (position) {
			this.player_position = -1;
			this.$nextTick(function() {
				this.player_position = position;
			});
		},
		step (change) {
			if (this.$refs.player) this.$refs.player.step(change);
		},
		step_frame (count) {
			if (this.$refs.player) this.$refs.player.step_frame(count);
		},
		seek_to_in_position () {
			this.seek(this.in_position);
		},
		seek_to_out_position () {
			this.seek(this.out_position);
		},
		player_loaded() {
			if (typeof(this.out_position) == "undefined") this.out_position = this.duration;
			if (typeof(this.in_position) == "undefined") this.in_position = 0;
			this.seek_to_in_position();
			this.update_slider();
		},
		arrow_step (code, altKey, shiftKey) {
			var dir = code == 37 ? -1 : 1;
			if (altKey && shiftKey) return this.step_frame(dir);
			var val = 1;
			if (altKey) val = 5;
			if (shiftKey) val = 10;
			this.step(dir * val);
		},
		stop_arrow_repeat () {
			clearInterval(this.arrow_timer);
			this.arrow_timer = undefined;
			this.held_arrow = undefined;
		},
		keyUp (event) {
			if (this.held_arrow && this.held_arrow.code == event.keyCode) this.stop_arrow_repeat();
		},
		keyDown(event) {
			if (event.keyCode == 83 && event.altKey && this.save_dialog) {
				 // S
				 event.preventDefault();
				this.$refs.clip_editor.save()
			}
			if(this.is_key_events_disabled) return;
			var target = event.target;
			if (target && (target.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName))) return;
 			if (event.keyCode == 83 && event.altKey) {
 				event.preventDefault();
 				this.save_dialog = true;
 			}
 			if (event.keyCode == 37 || event.keyCode == 39) {
 				// Own repeat is running, ignore native repeats
 				if (this.arrow_timer && event.repeat) return;
 				this.stop_arrow_repeat();
 				this.held_arrow = {code: event.keyCode, altKey: event.altKey, shiftKey: event.shiftKey};
 				this.arrow_step(event.keyCode, event.altKey, event.shiftKey);
 			}

			if (event.keyCode == 40) {
				this.set_in_position();
			}
			if (event.keyCode == 38) {
				this.set_out_position();
			}
			

 			if (event.keyCode == 81 && event.altKey) {
 				if (event.shiftKey) {
 					this.seek_to_in_position();
 				} else {
	 				this.set_in_position();
	 			}
 			}
 			if (event.keyCode == 87 && event.altKey) {
 				if (event.shiftKey) {
 					this.seek_to_out_position();
 				} else {
	 				this.set_out_position();
	 			}
 			}
 			if (event.keyCode == 82 && event.altKey) {
				// R
 				// The browser stops repeating the held arrow once another key is pressed
 				if (this.held_arrow && !this.arrow_timer) {
 					var held = this.held_arrow;
 					this.arrow_timer = setInterval(() => this.arrow_step(held.code, held.altKey, held.shiftKey), 33);
 				}
 				if (!event.repeat) this.refresh_player()
 			}
 			if (event.keyCode == 32 ) {
				 // Space
				event.preventDefault()
				if (this.$refs.player) {
					this.$refs.player.play_toggle()
				}
 			}
    }
	},
	computed: {
		mtv_special_visible() {
			return _.get(this.$store.state.account, "meta.mtv_special_import", false);
		},
		is_key_events_disabled() {
			return this.disableKeyEvents || this.tag_dialog || this.save_dialog;
		},
		use_save_dialog () {
			if (this.useSaveDialog != true) return false;
			return true;
		},
		is_slider () {
			return (typeof(this.duration) == "undefined");
		},
	},
	destroyed() {
		this.stop_arrow_repeat();
		window.removeEventListener('keydown', this.keyDown)
		window.removeEventListener('keyup', this.keyUp)
		window.removeEventListener('blur', this.stop_arrow_repeat)
	}

}
</script>

<style scoped>
.vod-help {
	padding: 12px 16px;
	max-width: 520px;
}
.vod-help-title {
	font-weight: 600;
	margin-bottom: 8px;
}
.vod-help table {
	border-collapse: collapse;
}
.vod-help td {
	padding: 3px 0;
	vertical-align: top;
}
.vod-help td:first-child {
	white-space: nowrap;
	padding-right: 16px;
}
.vod-help kbd {
	display: inline-block;
	min-width: 18px;
	padding: 1px 6px;
	text-align: center;
	font-family: inherit;
	font-size: 12px;
	border: 1px solid var(--ks-col-secondary);
	border-radius: 4px;
	background: var(--ks-background-color-dark);
}
.vod-help-note {
	margin-top: 8px;
	font-size: 12px;
	opacity: 0.7;
}
</style>
